import type { FindingSeverity } from "./Finding";

// Чем больше, тем хуже. По нему выбираются цвет секции и порядок ошибок у разборов без важности.
export const SEVERITY_RANK: Record<FindingSeverity, number> = { good: 0, warn: 1, bad: 2 };
